<template>
  <div class="support">
    <div class="idea">
      <h3>
        <span style="font-weight:600" class="titleColor">全方位五大支持</span>
      </h3>
      <div class="honor-line-wrapper">
        <div class="honor-line"></div>
      </div>
      <div class="meicai-five">
        <div class="meicai-five-item">
          <div class="meicai-five-img">
            <img width="88px" src="../../../assets/images/new-img/company/6.png">
          </div>
          <div class="meicai-five-title">品牌输出</div>
          <div class="eicai-five-content">
            <p class>作为行业领头羊美菜早已声名远播。</p>
          </div>
        </div>
        <div class="meicai-five-item">
          <div class="meicai-five-img">
            <img width="88px" src="../../../assets/images/new-img/company/7.png">
          </div>

          <div class="meicai-five-title">资源分享</div>
          <div class="eicai-five-content">
            <p class>集齐上万商品物美价廉，应有尽有。</p>
          </div>
        </div>
        <div class="meicai-five-item">
          <div class="meicai-five-img">
            <img width="88px" src="../../../assets/images/new-img/company/8.png">
          </div>

          <div class="meicai-five-title">技术保障</div>
          <div class="eicai-five-content">
            <p class>从订单、采购、加工、配送、财务、库存管理全闭环的业务场景，简单、快捷、精准。</p>
          </div>
        </div>
        <div class="meicai-five-item">
          <div class="meicai-five-img">
            <img width="88px" src="../../../assets/images/new-img/company/9.png">
          </div>
          <div class="meicai-five-title">经营支撑</div>
          <div class="eicai-five-content">
            <p class="“”">
              多年经验积累专业的营、采、销、仓、配专业输出。
              <br>
            </p>
          </div>
        </div>

        <div class="meicai-five-item">
          <div class="meicai-five-img">
            <img width="88px" src="../../../assets/images/new-img/company/10.png">
          </div>
          <div class="meicai-five-title">业务支持</div>
          <div class="eicai-five-content">
            <p class>
              一站式配送开创先河，让用户足不出户省心。
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "countyProfile",
  data() {
    return {
      dialogVisbility: false
    };
  }
};
</script>

<style lang="scss" scoped>
.support {
  width: 100%;
  padding: 50px 0;
}
.idea {
  width: 1000px;
  margin: 0 auto;
  h3 {
    font-size: 30px;
    text-align: center;
  }
}
.meicai-five {
  display: flex;
  margin-top: 100px;
  .meicai-five-item {
    width: 200px;
    .meicai-five-img {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 136px;
      overflow: hidden;
    }
    .meicai-five-title {
      text-align: center;
      font-size: 18px;
      color: #333333;
      margin-top: 40px;
      font-weight: 600;
    }
    .eicai-five-content {
      text-align: justify;
      margin-top: 20px;
      padding: 0 30px;
      font-size: 14px;
      line-height: 1.5
    }
  }
}
</style>
